import { db } from '../FirebaseLibrary';

export const createCustomFormsReference = (teamId: string) => {
    return db.collection(`teams/${teamId}/custom-forms`);
};

export const createCustomFormReference = (teamId: string, customFormId: string) => {
    return createCustomFormsReference(teamId).doc(customFormId);
};

export const fetchCustomFormFirestoreAPI = (teamId: string, customFormId: string) => {
    return createCustomFormReference(teamId, customFormId).get();
};

export const fetchCustomFormsFirestoreAPI = (teamId: string) => {
    return createCustomFormsReference(teamId).where('deleted', '==', false).orderBy('timeCreated', 'desc').get();
};
